import { useState } from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { label: "HOME", path: "/" },
  { label: "ABOUT", path: "/about" },
  { label: "PODCAST", path: "/podcast" },
  { label: "SHOP", path: "/shop" },
  { label: "CONTACT", path: "/contact" },
];

interface NavProps {
  backgroundColor?: string;
}

export default function Nav({ backgroundColor }: NavProps) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <nav
      className="border-b border-black/[0.09] w-full"
      style={backgroundColor ? { background: backgroundColor } : undefined}
    >
      {/* Mobile bar: hamburger only */}
      <div className="sm:hidden flex items-center justify-between px-4 py-3">
        <span
          className="font-montserrat font-medium text-stone-800"
          style={{ fontSize: "12px", letterSpacing: "0.14em" }}
        >
          THAT'S GIRL CODE
        </span>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          className="flex flex-col items-center justify-center gap-[5px] p-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-burgundy"
        >
          <span
            className={`block h-[2px] w-6 bg-stone-800 transition-transform duration-200 ${
              open ? "translate-y-[7px] rotate-45" : ""
            }`}
          />
          <span
            className={`block h-[2px] w-6 bg-stone-800 transition-opacity duration-200 ${
              open ? "opacity-0" : "opacity-100"
            }`}
          />
          <span
            className={`block h-[2px] w-6 bg-stone-800 transition-transform duration-200 ${
              open ? "-translate-y-[7px] -rotate-45" : ""
            }`}
          />
        </button>
      </div>

      {/* Desktop links */}
      <div className="hidden sm:flex flex-wrap justify-center items-center gap-x-4 gap-y-2 sm:gap-8 md:gap-12 py-3 px-4 sm:px-6">
        {LINKS.map(({ label, path }) => (
          <Link
            to={path}
            key={label}
            className="group relative font-montserrat font-medium text-stone-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-burgundy"
            style={{
              fontSize: "12px",
              letterSpacing: "0.14em",
            }}
          >
            <span className="transition-opacity duration-200 group-hover:opacity-70">
              {label}
            </span>
            <span
              aria-hidden="true"
              className="pointer-events-none absolute left-0 right-0 -bottom-1 h-px origin-left scale-x-0 bg-burgundy transition-transform duration-300 ease-out group-hover:scale-x-100"
            />
          </Link>
        ))}
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="sm:hidden flex flex-col items-center gap-5 py-5 border-t border-black/[0.09] animate-fade-in">
          {LINKS.map(({ label, path }) => (
            <Link
              to={path}
              key={label}
              onClick={close}
              className="font-montserrat font-medium text-stone-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-burgundy"
              style={{
                fontSize: "14px",
                letterSpacing: "0.18em",
              }}
            >
              {label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
